"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _lodash = require("lodash");
var _mobx = require("mobx");
var _class, _descriptor, _descriptor2, _descriptor3;
var RouteStore = (_class = /*#__PURE__*/function () {
  function RouteStore() {
    (0, _classCallCheck2["default"])(this, RouteStore);
    (0, _initializerDefineProperty2["default"])(this, "routerIsSetup", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "routeName", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "params", _descriptor3, this);
  }
  return (0, _createClass2["default"])(RouteStore, [{
    key: "setRouter",
    value: function setRouter(router) {
      this.router = router;
      this.routerIsSetup = true;
    }
  }, {
    key: "setRouteName",
    value: function setRouteName(routeName, callback) {
      this.routeName = routeName;
      if ((0, _lodash.isFunction)(callback)) {
        callback();
      }
    }
  }, {
    key: "pathname",
    value: function pathname() {
      return this.router ? this.router.location.pathname : null;
    }
  }, {
    key: "childRoute",
    value: function childRoute() {
      return (0, _lodash.last)(this.router.routes);
    }
  }, {
    key: "routeTo",
    value: function routeTo(path) {
      this.router.push(path);
    }
  }, {
    key: "routeToNamed",
    value: function routeToNamed(name, params, callback) {
      this.router.push({
        name: name,
        params: params
      });
      this.setRouteName(name, callback);
      this.params = params;
    }
  }, {
    key: "updateUrl",
    value: function updateUrl(url) {
      window.history.pushState({}, null, url);
    }
  }, {
    key: "queryParam",
    value: function queryParam(name) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "routerIsSetup", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "routeName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "params", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
var _default = exports["default"] = new RouteStore();